import { QueryOptions, queryOptions } from '@tanstack/react-query';
import { service } from '@maia/claim';

export type Claims = Awaited<ReturnType<(typeof service)['getClaims']>>;

export function getClaimsOptions(
  search: Record<string, unknown> = {},
  initialData: QueryOptions<Claims>['initialData'] = undefined,
) {
  return queryOptions({
    queryKey: ['claims', 'claims', [search]],
    queryFn: async () => await service.getClaims(search),
    initialData,
  });
}
